import { getAccessibleCourses, hasCourses } from '../../utils/learningCourseUtils';
import PromoBox from '../includes/PromoBox';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

const LearningCourses = () => {
  const userDetails = useSelector((state) => state.user.details);
  const catalogue = useSelector((state) => state.config.content?.learningCourses);
  const learningPageElementalArea = useSelector((state) => state.config.content?.learningPageElementalArea);
  const learningPdfDescription = useSelector((state) => state.config.content?.learningPdfDescription);
  const userHasCourses = hasCourses(userDetails);
  const courses = getAccessibleCourses(userDetails, catalogue);
  const hasCompletedCourse = courses.some((course) => course.completed);

  const [elementalSlot] = useState(() => document.getElementById('learning-page-elemental-slot'));
  const [continuationSlot] = useState(() => document.getElementById('frank-learning-continuation'));

  const coursesContent = (
    <div className="container content mb-5">
      <div className="row middle">
        {!userHasCourses && (
          <div className="col-lg-12 mb-4">
            <p>You do not have access to any Learning.</p>
          </div>
        )}

        {userHasCourses && (
          <div className="col-12 mt-4">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
              {courses.map((course) =>
                course.comingSoon ? (
                  <div key={course.code} className="col frank-tile">
                    <div className="bg-light-grey p-4 h-100 course-tile-body">
                      <div>
                        <h3>{course.name}</h3>
                        {course.description && <p className="mb-1">{course.description}</p>}
                        <p className="mb-2">
                          <strong>Available soon</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div key={course.code} className="col frank-tile">
                    <Link to={`/learning/${course.code}`} target="_blank" rel="noopener noreferrer">
                      <div className="bg-mint p-4 h-100 course-tile-body">
                        <div>
                          <h3>{course.name}</h3>
                          {course.description && <p className="mb-1">{course.description}</p>}
                          {course.estimatedDuration && (
                            <p className="mb-2">
                              <strong>Estimated duration: {course.estimatedDuration}</strong>
                            </p>
                          )}
                        </div>

                        {course.completed && (
                          <div className="course-tile-completed">
                            <div className="course-tile-completed-label">Completed</div>
                            <div className="course-tile-completed-icon">
                              <span className="fa fa-check fa-lg text-success" aria-hidden="true" />
                            </div>
                          </div>
                        )}
                      </div>
                    </Link>
                  </div>
                ),
              )}
            </div>

            {hasCompletedCourse && (
              <div className="row g-4 mt-5">
                <div className="col-md-8">
                  <div className="bg-mint p-4">
                    {learningPdfDescription ? (
                      /* eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml */
                      <div className="typography mb-3" dangerouslySetInnerHTML={{ __html: learningPdfDescription }} />
                    ) : null}
                    <a href="/learning-course-confirmation-of-completion-pdf" className="btn btn-primary d-inline-block">
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <PromoBox>
        <h1>Learning</h1>
      </PromoBox>

      {userHasCourses && learningPageElementalArea && elementalSlot
        ? createPortal(
            // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
            <div dangerouslySetInnerHTML={{ __html: learningPageElementalArea }} />,
            elementalSlot,
          )
        : null}

      {continuationSlot ? createPortal(coursesContent, continuationSlot) : coursesContent}
    </div>
  );
};

export default LearningCourses;
